import { Link } from 'react-router-dom';

const safetyTips = [
  'Zawsze sprawdzaj opinie innych użytkowników przed zakupem',
  'Korzystaj wyłącznie ze sprawdzonych metod płatności',
  'Porównuj ceny produktów w różnych kategoriach arkusza',
  'Regularnie sprawdzaj aktualizacje bazy produktów',
  'Czytaj przewodniki bezpieczeństwa na naszej stronie',
  'Weryfikuj informacje o dostawcy przed finalizacją zamówienia',
  'Zapisuj historię swoich transakcji i korespondencji',
];

export default function SafetySection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-2">
              Czy Kakobuy jest bezpieczny?
            </h2>
            <p className="text-sm text-accent-500 font-medium mb-4">
              7 rzeczy, które musisz wiedzieć przed zakupem
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              Bezpieczeństwo zakupów online jest priorytetem dla każdego użytkownika. Kakobuy to platforma, która zyskała zaufanie tysięcy klientów na całym świecie. Przed dokonaniem zakupu warto zapoznać się z podstawowymi zasadami bezpieczeństwa, sprawdzić opinie innych użytkowników oraz korzystać ze sprawdzonych metod płatności.
            </p>
            <ul className="space-y-2.5 mb-6">
              {safetyTips.map((tip, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary-500 text-xs"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{tip}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/artykul/bezpieczenstwo-kakobuy-poradnik"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
            >
              Przeczytaj pełny przewodnik
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Conceptual%20trust%20and%20security%20photography%20showing%20a%20kraft%20paper%20shipping%20box%20with%20a%20subtle%20metallic%20shield%20emblem%20beside%20it%20on%20a%20clean%20light%20wood%20surface%20a%20smartphone%20displaying%20verified%20purchase%20confirmation%20screen%20next%20to%20a%20small%20green%20succulent%20plant%20warm%20reassuring%20natural%20light%20from%20above%20conveying%20safety%20reliability%20protection%20minimalist%20aesthetic&width=800&height=600&seq=kakobuy-safety-img-v3-03&orientation=landscape"
              alt="Bezpieczeństwo Kakobuy – poradnik dla polskich użytkowników"
              title="Czy Kakobuy jest bezpieczny? Poradnik bezpieczeństwa"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}